import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Users } from '../../shared-datatypes/users';
import { SharingPanelService } from '../../shared-service/sharing-panel-service';
import { BaseService } from '../../shared-service/base.service';
//import { Util } from '../../shared-service/util.service';
import { WindowRef } from '../../shared-service/windowRef.service';

import { Observable, Subject, of, catchError } from 'rxjs';

// Observable class extensions
import {switchMap, debounceTime, distinctUntilChanged} from 'rxjs/operators';

declare var Tree: any;
declare var $: any;

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class UserListComponent implements OnInit, OnDestroy {

	@Input() parentName: string | any;

	selectUserList: boolean = false;
	UserIdList: Array<any> = [];

	userListData: Array<Users> | any;

	public uData: Observable<Users[]> = of([]);

	selectedItems: string = '';
	//selectedItemsNames: string = '';
	rootObj: object | any;

	private searchTerms = new Subject<string>();
	private subs: any;
	private checkBoxTriggered: boolean = false;

	constructor(private sps: SharingPanelService, public bs: BaseService,private winRef:WindowRef) { }

	ngOnInit() {
		console.log('ngOnInit UserListComponent');
		console.log(this.parentName);
		this.subs = this.sps.changeDetected.subscribe((data) => {
			this.checkBoxTriggered = true;
			if (this.selectUserList) {
				this.selectedItems = this.sps.refreshList();
				this.getList();
			}
		})
	}

	ngOnDestroy() {
		console.log("Destroyed", "UserListComponent");
		this.subs.unsubscribe();
	}

	getList() {
		let params : any = {};
		if (this.parentName === 'SharingPanelComponent') {
			params['SelectedFieldDetails'] = this.selectedItems;
			console.log('SelectedFieldDetails', this.selectedItems);
		}
		this.sps.getUserList(params, "******", this.parentName).then((res:any) => {
			this.userListData = res['lstUserDetails'];
			this.uData = res['lstUserDetails'] as Observable<Users[]>;
			this.loadList();
		}, (err) => {
			console.log(err);
		});
	}

	radioChanged(ev: Event | any) {
		console.log(ev.target['value']);
		if (ev.target['value'] === 'selectUser') {
			this.selectUserList = true;
			if (this.checkBoxTriggered) {
				this.selectedItems = this.sps.refreshList();
			}
			this.getList();
		} else {
			this.selectUserList = false;
			this.UserIdList = [];
		}
	}

	// refreshList() {
	// 	this.rootObj = this.sps.treeData['data'];
	// 	console.log(this.rootObj);
	// 	this.selectedItems = '';
	// 	//this.selectedItemsNames = '';
	// 	let el = this.winRef.nativeWindow.document.getElementById(this.sps.treeData['rootId']);
	// 	let inputAr = el.getElementsByTagName('input');
	// 	for (var i = 0; i < inputAr.length; i++) {
	// 		if(inputAr[i]['checked']) {
	// 			let arrRoute = inputAr[i]['value'].split('-');
	// 			if (arrRoute[0] == 'true') {
	// 				let nEl = this.winRef.nativeWindow.document.getElementById('ul'+arrRoute[1]+this.sps.treeData['rootId']);
	// 				this.selectedItems = this.selectedItems + arrRoute[1] + ',';
	// 				//this.selectedItemsNames = this.selectedItemsNames + this.winRef.nativeWindow.document.getElementById('label'+arrRoute[1]+'rootTree').innerText + ',';
	// 				if (nEl == null) {
	// 					this.findChilds(arrRoute);
	// 				}
	// 			} else {
	// 				this.selectedItems = this.selectedItems + arrRoute[1] + ',';
	// 				//this.selectedItemsNames = this.selectedItemsNames + this.winRef.nativeWindow.document.getElementById('label'+arrRoute[1]+'rootTree').innerText + ',';
	// 			}
	// 		}
	// 	}
	// 	console.log(this.selectedItems);
	// 	//console.log(this.selectedItemsNames);
	// 	this.getList();
	// }

	// findChilds(arrRoute: Array<string>) {
	// 	let tmpObj = this.rootObj;
	// 	for (let i = 3; i < arrRoute.length; i++) {
	// 		tmpObj = tmpObj['childs'][arrRoute[i]];
	// 	}
	// 	this.doAddIds(tmpObj);
	// }

	// doAddIds(tmpObj) {
	// 	if (tmpObj['childs'] != null) {
	// 		for (let i = 0; i < tmpObj['childs'].length; i++) {
	// 			this.selectedItems = this.selectedItems + tmpObj['childs'][i]['id'] + ',';
	// 			//this.selectedItemsNames = this.selectedItemsNames + tmpObj['childs'][i]['label'] + ',';
	// 			this.doAddIds(tmpObj['childs'][i]);
	// 		}
	// 	}
	// }

	// /*findParentPath(arrRoute: Array<string>) {
	// 	let tmpObj = this.rootObj;
	// 	for (let i = 3; i < arrRoute.length; i++) {
	// 		tmpObj = tmpObj['childs'][arrRoute[i]];
	// 		this.selectedItems = this.selectedItems + tmpObj['id'] + ',';
	// 	}
	// }*/

	noData: Array<Users> = [{UserId: 1, UserName: this.bs.getResource('rbkey_NoUsr')}];

	loadList() {
		this.uData = this.searchTerms
			.pipe(
				debounceTime(300),        // wait 300ms after each keystroke before considering the term
				distinctUntilChanged(),   // ignore if next search term is same as previous
				switchMap(term => term ? this.searchList(term) : of(this.noData))
				,catchError(error => {
					console.log(error);
					return of<Users[]>([]);
				})
			);
	}

	searchList(sTerm: string): Observable<Users[]> {
		return of(this.userListData.filter((data:any) => data['UserName'].toLowerCase().indexOf(sTerm) != -1));
	}

	selectTag(id: any, name: string) {
		let tag : any= this.winRef.nativeWindow.document.getElementById('user' + id);
		if (tag['checked']) {
			this.UserIdList.push({ 'id': id, 'uName': name });
			this.UserIdList = this.RemoveDuplicates(this.UserIdList, "id");
		} else {
			var removeIndex = this.UserIdList.map(function (item) { return item.id; }).indexOf(id);
			~removeIndex && this.UserIdList.splice(removeIndex, 1);
		}
	}

	toggleSearch() {
		if ($('#SearchForm').hasClass('hide')) {
			$('#SearchForm').removeClass('hide');
			$('#searchText').val('');
			$('#searchText').focus();
		} else {
			$('#SearchForm').addClass('hide');
		}
	}

	search(sText: string) {
		this.searchTerms.next(sText);
	}

	toggleChips(id: string) {
		$('#chips' + id).remove();
		var removeIndex = this.UserIdList.map(function (item) { return item.id; }).indexOf(id);
		~removeIndex && this.UserIdList.splice(removeIndex, 1);
		if(this.UserIdList.length==0){
			this.winRef.nativeWindow.document.getElementById('user' + id)['checked'] = false;
			$('#searchText').val('');
			this.loadList();
		} else {
			this.winRef.nativeWindow.document.getElementById('user' + id)['checked'] = false;
		}
	}

	keyDownFunction(event:any) {
		if (event.keyCode == 13) {
			event.preventDefault();
		}
	}

	RemoveDuplicates(originalArray:any, prop:any) {
		var newArray = [];
		var lookupObject :any = {};

		for (var i in originalArray) {
			lookupObject[originalArray[i][prop]] = originalArray[i];
		}

		for (i in lookupObject) {
			newArray.push(lookupObject[i]);
		}
		return newArray;
	}


}
